/* eslint-disable import/prefer-default-export */
export const DEFAULT_TIMEZONE = 'America/New_York';
